export default {
  className: 'popularSearch',
  fields: [
    {
      name: 'word',
      validators: [
        (val) => val ? null : '搜索词不可为空'
      ]
    }
  ],
  search: [
    'word'
  ]
}
